// Supabase disabled – backend API is the source of truth
export const supabase = null;
